// TODO: reflect this based on payhere integration statuses

export enum PaymentStatus {
  Pending = 10,
  Successful = 20,
  Failed = -10,
}
